import {useTranslations} from 'next-intl';

export default function ProductDetailsColors({ setCurrentColor }) {
  const t = useTranslations('catalog');
  
  const colors = ["black", "white", "red", "yellow", "green", "blue", "navy"];
  return (
    <li>
      <div className="ltn__color-widget clearfix">
        <strong className="alignleft">{t('color')}</strong>
        <ul>
          {colors?.map((color, idx) => (
              <li key={idx} className={`${color} me-2`}>
                <span className="linkable" onClick={() => setCurrentColor(color)}></span>
              </li>
          ))}
        </ul>
      </div>
    </li>
  );
};
